<template>
	<div>
		<v-container align="center" justify="center" class="pa-5">
			<v-row justify="center" no-gutters>
				<v-col cols="auto">
					<v-icon size="100px" color="primary" @click="uploadFile">backup</v-icon>
				</v-col>
			</v-row>
			<v-row class="justify-center text-center"
				><v-col style="text-transform: none !important"
					><v-btn class="text-none text-wrap" text color="primary">
						<v-file-input
							ref="idFileInput"
							v-model="idfile"
							:class="{ 'body-1': $vuetify.breakpoint.mdAndUp, caption: $vuetify.breakpoint.smAndDown, 'custom-file-uploader': true }"
							accept=".png, .jpg, .jpeg, .gif, .pdf"
							placeholder="Upload ID document"
							show-size
							:truncate-length="15"
							:rules="rules"
							:prepend-icon="''"
							prepend-inner-icon="cloud_upload"
							style="border: none; color: var(--v-primary-base)"
							@change="handleImage" /></v-btn></v-col
			></v-row>
			<v-row class="justify-center text-center">
				<v-col class="error--text">
					<v-card-text v-show="idError">Please upload an ID document</v-card-text>
				</v-col>
			</v-row>
			<v-row v-if="idExists" align="center" justify="center" class="mb-6">
				<v-col cols="auto" class="text--secondary" style="font-size: 15px">ID document already uploaded. Click above to upload a new document.</v-col>
			</v-row>
			<v-row align="center" justify="center">
				<v-col cols="auto" class="text--secondary text-caption">Supported file formats: PDF, JPG, GIF, PNG</v-col>
			</v-row>
			<v-row align="center" justify="center" no-gutters>
				<v-col cols="auto" class="text--secondary text-caption">Maximum upload file size: 2MB</v-col>
			</v-row>
		</v-container>

		<v-container align="center" justify="center">
			<v-row class="justify-center text-center"
				><v-col cols="auto"> <v-img v-show="showPreview" :max-width="483" :max-height="327" :src="idFilePreview"></v-img> </v-col
			></v-row>
		</v-container>
	</div>
</template>

<script>
import axios from 'axios';
import store from '@/store';
import { bus } from '@/main';

export default {
	components: {},
	data: () => ({
		idfile: null,
		step: 'upload-id-step',
		uploadedImageBase64: null,
		rules: [value => !value || value.size < 2097152 || 'File size should be less than 2 MB'],
		showPreview: false,
		idExists: false,
		idDownloadLink: null,
		idError: false,
	}),

	computed: {
		user: function () {
			return store.getters.user;
		},
		idFilePreview: function () {
			return this.uploadedImageBase64;
		},
	},

	async mounted() {
		window.scrollTo(0, 0);

		this.idExists = this.user?.documents?.images?.includes('identity_document');

		if (!this.idExists && !this.idfile) {
			this.idError = true;
		}

		bus.$on('intent:submit-forms', data => {
			if (!this.idError) {
				bus.$emit('update:spinning', true);
				this.postToBackend(data);
			}
		});
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
	},

	methods: {
		handleImage(image) {
			if (image) {
				this.idError = false;
				const selectedImage = image;
				this.createBase64Image(selectedImage);
				this.showPreview = true;
			} else {
				this.showPreview = false;
			}
		},
		createBase64Image(fileObject) {
			const reader = new FileReader();

			reader.onload = e => {
				this.uploadedImageBase64 = e.target.result;
			};

			reader.readAsDataURL(fileObject);
		},
		uploadFile() {
			this.$refs.idFileInput.$refs['input'].click();
		},

		checkStep(user) {
			if (user?.documents?.images?.includes('identity_document')) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},

		async postToBackend() {
			const token = store.getters.jwtToken;
			if (this.idExists) {
				bus.$emit('intent:next-step', 'upload-id-step');
				bus.$emit('update:spinning', false);
			}

			if (this.idfile) {
				try {
					await axios.post(store.getters.getDOCUMENTS + '/images/identity_document/' + store.getters.user.id, this.uploadedImageBase64, {
						headers: { Authorization: token },
					});
					if (!('documents' in store.getters.user && store.getters.user.documents.images.some(img => img == 'identity_document'))) {
						let save = await axios.put(store.getters.getAPI + '/professionals/documents/images/', { doc: 'identity_document' }, { headers: { Authorization: token } });
						await store.commit('SET_USER', save.data.data); //refresh the users state. await it completed.
					}
					bus.$emit('intent:next-step', 'upload-id-step');
				} catch (err) {
					console.error(err);
				} finally {
					bus.$emit('update:spinning', false);
				}
			}
		},

		getStep() {
			return 'upload-id-step';
		},
		getText() {
			return 'upload ID';
		},
	},
};
</script>
